import { loadStripe } from '@stripe/stripe-js'

export default {
  data() {
    return {
      cardNumberStripeElement: null,
      cardExpiryStripeElement: null,
      cardCvcStripeElement: null,
    }
  },
  methods: {
    async initStripe(publishableKey, stripeItemID) {
      // Load Stripe.js with your publishable key
      this.stripe = await loadStripe(publishableKey)
      const elements = this.stripe.elements()

      const style = {
        style: {
          base: {
            fontSize: '16px',
            color: process.env.SECONDARY_COLOR,
            backgroundColor: '#EDEDED',
            '::placeholder': {
              color: process.env.SECONDARY_COLOR,
            },
          },
        },
      }

      // Create and mount the card number input field
      this.cardNumberStripeElement = elements.create('cardNumber', style)
      this.cardNumberStripeElement.mount('#card-number-' + stripeItemID)
      this.cardNumberStripeElement.addEventListener('change', (event) => {
        if (event.error) {
          this.$store.commit('formValidation/setCreditCardFormError', {
            field: 'card_number',
            value: event.error.message,
          })
        } else {
          this.$store.commit('formValidation/setCreditCardFormError', { field: 'card_number', value: false })
        }
      })

      this.cardExpiryStripeElement = elements.create('cardExpiry', style)
      this.cardExpiryStripeElement.mount('#card-expiry-' + stripeItemID)
      this.cardExpiryStripeElement.addEventListener('change', (event) => {
        if (event.error) {
          this.$store.commit('formValidation/setCreditCardFormError', {
            field: 'card_expiry',
            value: event.error.message,
          })
        } else {
          this.$store.commit('formValidation/setCreditCardFormError', { field: 'card_expiry', value: false })
        }
      })

      this.cardCvcStripeElement = elements.create('cardCvc', style)
      this.cardCvcStripeElement.mount('#card-cvc-' + stripeItemID)
      this.cardCvcStripeElement.addEventListener('change', (event) => {
        if (event.error) {
          this.$store.commit('formValidation/setCreditCardFormError', {
            field: 'card_cvc',
            value: event.error.message,
          })
        } else {
          this.$store.commit('formValidation/setCreditCardFormError', { field: 'card_cvc', value: false })
        }
      })
    },
    async fetchStripeCardToken(stripeItemID) {
      const { token, error } = await this.stripe.createToken(this.cardNumberStripeElement)
      if (error) {
        // handle error here
        document.getElementById('#' + stripeItemID + 'card-error').innerHTML = error.message
        return
      }

      return token
    },
    async destroyMountedForm() {
      if (this.cardNumberStripeElement) {
        this.cardNumberStripeElement.destroy()
      }
      if (this.cardExpiryStripeElement) {
        this.cardExpiryStripeElement.destroy()
      }
      if (this.cardCvcStripeElement) {
        this.cardCvcStripeElement.destroy()
      }
    }
  },
}